import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "./LoginActionType";
import * as actions from "./LoginActions";
import * as authService from "./LoginServices";
import { deleteCookie, setCookie } from "../../../store/localStorage";

function* loginSaga(action) {
  try {
    const { isCustomLogin, EmailAddress, Password, instance, accounts } =
      action.payload;

    if (isCustomLogin) {
      const response = yield call(authService.customLogin, {
        EmailAddress,
        Password,
      });
      const cookieExpiry = response.values.JwtExpirationTime;
      yield call(setCookie, "authToken", response.values.TKN, cookieExpiry);
      yield call(
        setCookie,
        "userData",
        response.values.userDetailModel,
        cookieExpiry,
      );
      yield call(setCookie, "jwtExpirationTime", cookieExpiry, cookieExpiry);
      yield put(actions.loginSuccess(response.values.userDetailModel));
    } else {
      const tokenResponse = yield call(authService.handleMicrosoftLogin, {
        instance,
        accounts,
      });
      const payload = {
        UserName: tokenResponse?.account?.name,
        EmailAddress: tokenResponse?.account?.username,
      };
      const response = yield call(authService.login, payload);
      const cookieExpiry = response.values.JwtExpirationTime;
      yield call(setCookie, "authToken", response.values.TKN, cookieExpiry);
      yield call(
        setCookie,
        "userData",
        response.values.userDetailModel,
        cookieExpiry,
      );
      yield call(setCookie, "jwtExpirationTime", cookieExpiry, cookieExpiry);
      yield put(actions.loginSuccess(response.values.userDetailModel));
    }
  } catch (error) {
    yield put(actions.loginFailure(error));
  }
}

function* logoutSaga() {
  try {
    yield call(deleteCookie, "jwtExpirationTime");
    yield call(deleteCookie, "authToken");
    yield call(deleteCookie, "userData");
    yield put(actions.logoutSuccess());
  } catch (error) {
    yield put(actions.logoutFailure(error));
  }
}

export default function* watchAuthSaga() {
  yield takeLatest(types.LOGIN_REQUEST, loginSaga);
  yield takeLatest(types.LOGOUT_REQUEST, logoutSaga);
}
